import { gql } from '@apollo/client';

export const disclaimTerritoryMembershipMutation = gql`
  mutation disclaimTerritoryMembershipMutation($territoryId: ID!) {
    disclaimTerritoryMembership(territoryId: $territoryId)
  }
`;
